export default function PersyaratanPendanaan(){
    return (
        <div className='container-alur'>
            <div className='persyaratan-pendanaan'>
                <div className='text-container'>
                    <h2 className='text-header'>Persyaratan Pemberi Pinjaman</h2>
                </div>
                <div className='dokumen-container'>
                    <img src={require('../../../../assets/img/product/ktp.png')} alt='ktp'/>
                    <img src={require('../../../../assets/img/product/npwp.png')} alt='npwp'/>
                    <img src={require('../../../../assets/img/product/foto-selfie.png')} alt='selfie'/>
                </div>
            </div>
        </div>
    );
}